module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-home-doctor"
  }, [_c('TitleTrigger', {
    staticClass: "custom-home-doctor__title-trigger",
    attrs: {
      "props": 1
    }
  }), _c('Trigger', {
    staticClass: "custom-home-doctor__trigger",
    attrs: {
      "props": 1
    }
  }), _c('div', {
    staticClass: "custom-home-doctor__container"
  }, [_c('div', {
    staticClass: "custom-home-doctor__row"
  }, [_c('div', {
    staticClass: "custom-home-doctor__col-left"
  }, [_c('div', {
    staticClass: "custom-home-doctor__image"
  }, [_c('div', {
    staticClass: "overlay",
    class: {
      active: _vm.active >= 1
    }
  }), _c('div', {
    staticClass: "image",
    style: ("backgroundImage: url(" + _vm.props.image + ");")
  })])]), _c('div', {
    staticClass: "custom-home-doctor__col-right"
  }, [_c('div', {
    staticClass: "custom-home-doctor__text-box",
    class: {
      active: _vm.active >= 1
    }
  }, [_c('div', {
    staticClass: "custom-home-doctor__title",
    class: {
      active: this.titleActive
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  }), _c('div', {
    staticClass: "custom-home-doctor__tagline",
    domProps: {
      "innerHTML": _vm._s(_vm.props.tagline)
    }
  }), _c('div', {
    staticClass: "custom-home-doctor__logos"
  }, _vm._l((_vm.props.logos), function(item, i) {
    return _c('Icon', {
      key: i,
      staticClass: "custom-home-doctor__logo",
      attrs: {
        "name": item.logo
      }
    })
  })), _c('div', {
    staticClass: "custom-home-doctor__content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content)
    }
  }), _c('router-link', {
    staticClass: "custom-home-doctor__link-text",
    attrs: {
      "to": "/our-office#doctor"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.link_text)
    }
  })], 1)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29082953","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-home-doctor/custom-home-doctor.pug
// module id = 627
// module chunks = 1